export enum Variants {
  critical = 'critical',
  caution = 'caution',
  positive = 'positive',
  neutral = 'neutral',
  info = 'info',
  promote = 'promote',
}
